import React, { useEffect, useState } from "react";
import CgFormCreator from "../../common/CgFormCreator";
import "./forgotPassword.scss";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchForgotPassword } from "../../store/Login/LoginActions";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [emailNotFound, setEmailNotFound] = useState(false);
  const [, setIsButttonEnabled] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { forgotPasswordError, isForgotPasswordLoading } = useSelector(
    (state) => state.forgotPassword
  );

  useEffect(() => {
    if (isForgotPasswordLoading) return null;
    if (forgotPasswordError === null) return;

    if (forgotPasswordError) {
      setError(false);
      setEmailNotFound(true);
    } else {
      setError(false);
      setSubmitted(true);
      setEmailNotFound(false);
    }
  }, [forgotPasswordError]);

  const handleSubmit = (value) => {
    const data = {
      username: value?.email,
    };
    if (!email || error) {
      setError(true);
    } else {
      dispatch(fetchForgotPassword(data));
    }
  };

  const handleLogin = () => {
    navigate("/login");
  };

  const handleReset = () => {
    setEmailNotFound(false);
    setSubmitted(false);
    setError(true);
    setEmail("");
    setIsButttonEnabled(false);
  };

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(String(email).toLowerCase());
  };

  const ForgotPasswordSchema = [
    {
      component: "input",
      type: "email",
      name: "email",
      validateEmail: "email",
      required: true,
      placeholder: "Email",
      onKeyChangeCallback: (name, value) => {
        setEmail(value);
        if (!validateEmail(value)) {
          setError(true);
          setIsButttonEnabled(false);
        } else {
          setError(false);
          setIsButttonEnabled(true);
        }
      },
      valueChangeCallback: () => {},
    },
  ];

  const RenderForgotPasswordFormCreator = () => {
    return (
      <>
        <div className="forgot-password-container">
          <h2>Forgot Password ?</h2>
          <p>Please enter your email address to reset your password.</p>
        </div>
        <div className="forgot-password-container-2">
          <CgFormCreator
            schema={ForgotPasswordSchema}
            primaryButton={
              <span>
                Reset Password <i className="bi bi-chevron-right" />
              </span>
            }
            enablePrimaryBtn={validateEmail(email)}
            noCancel
            onSubmitCallback={(value) => {
              handleSubmit(value);
            }}
          />
        </div>
      </>
    );
  };

  const renderEmailSentPage = () => {
    return (
      <div className="email-sent-page">
        <h2>Password Change Email Sent</h2>
        <p>
          We just emailed you a link to reset your password. The next step is to
          check your email and click the link.
        </p>
      </div>
    );
  };

  const renderEmailNotFoundPage = () => {
    return (
      <div className="email-not-found-page">
        <h2>Account Not Found</h2>
        <p>We couldn`t find your account. What next?</p>
        <div className="overall">
          <div className="button-container">
            <button onClick={handleLogin}>
              TRY LOGGING IN AGAIN <i className="bi bi-chevron-right"></i>{" "}
            </button>
            <button onClick={handleReset}>
              RESET PASSWORD <i className="bi bi-chevron-right"></i>
            </button>
          </div>
        </div>
        <p>Contact support: 424-316-2534</p>
      </div>
    );
  };

  return (
    <div className="forgot-password-wrapper">
      {/* {RenderForgotPasswordFormCreator()}
      {submitted && renderEmailSentPage()}
      {!emailNotFound && renderEmailNotFoundPage()} */}
      {!submitted && !emailNotFound
        ? RenderForgotPasswordFormCreator()
        : submitted
        ? renderEmailSentPage()
        : renderEmailNotFoundPage()}
    </div>
  );
};
export default ForgotPassword;
